import { render, staticRenderFns } from "./AuthPages.vue?vue&type=template&id=7ef13354"
import script from "./AuthPages.vue?vue&type=script&lang=js"
export * from "./AuthPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports